<template>
	<div class="min-h-screen" style="margin-bottom: 17vh;">
		<navbar></navbar>
		<div class="carousel">
			<img :src="image" />

			<div class="carousel-indicators">

				<div class="flex justify-between items-center h-full">
					<div class="text-center flex-1">
						<div class="bigGreen-text">2400万+</div>
						<div>注册用户</div>
					</div>
					<div class="text-center flex-1">
						<div class="bigGreen-text">12.3万</div>
						<div>月下单量</div>
					</div>
					<div class="text-center flex-1">
						<div class="bigGreen-text">43万+</div>
						<div class="">日均浏览量</div>
					</div>
				</div>
       <div class="topSettledbtn">
<!--					<el-button @click="handleSettaled" type="primary" class="mx-auto mt-6 settledbtn topSettledbtn">立即加盟</el-button>-->
      </div>
			</div>
		</div>
		<div class="bg-gradient-to-b from-blue-50 to-white">
			<div class="mx-auto px-4 py-16 max-width mx-auto">
				<!-- 标题区域 -->
				<div class="text-center mb-16">
					<h1 class="text-3xl font-bold text-gray-800 mb-2">三大核心优势赋能</h1>
					<p class="text-lg text-color-cb" style="font-weight:300;">THREE CORE ADVANTAGES EMPOWER</p>
				</div>
				<!-- 优势卡片区域 -->
				<div class="grid grid-cols-1 md:grid-cols-3 gap-8 mx-auto">
					<!-- 优势卡片 1 -->
					<div class="advantage-card">
						<div class="advantage-image-wrapper">
							<img :src="imageUrls.supply" alt="供应链优势" class="w-full h-full object-cover" />
						</div>
						<h3 class="text-xl font-bold text-gray-800 mt-6 mb-3">品牌全 货源稳 价格低</h3>
						<p class="font-c6 text-lg leading-relaxed mb-6">
							平台深度整合供应链体系<br />
							各品牌进货采购更具价格优势
						</p>
					</div>
					<!-- 优势卡片 2 -->
					<div class="advantage-card">
						<div class="advantage-image-wrapper">
							<img :src="imageUrls.traffic" alt="流量优势" class="w-full h-full object-cover" />
						</div>
						<h3 class="text-xl font-bold text-gray-800 mt-6 mb-3">线上+线下流量双引擎</h3>
						<p class="font-c6 text-lg leading-relaxed mb-6">
							线上：5大流量入口 流量大 出租快 <br />
							线下：网点合作成熟 助力出租
						</p>
					</div>
					<!-- 优势卡片 3 -->
					<div class="advantage-card">
						<div class="advantage-image-wrapper">
							<img :src="imageUrls.enterprise" alt="企业优势" class="w-full h-full object-cover" />
						</div>
						<h3 class="text-xl font-bold text-gray-800 mt-6 mb-3">
							新三板创新层企业<br />深耕通信行业21年
						</h3>
						<p class="font-c6 text-lg leading-relaxed mb-6">拥有手机相关充分资源</p>
					</div>
				</div>
			</div>
		</div>
		<div class="min-h-screen bg-gradient-to-b bg-neutral-100">
			<div class="container mx-auto px-4 py-16 max-width bg-neutral-100">
				<!-- 主标题 -->
				<div class="text-center mb-16">
					<h1 class="text-3xl font-bold text-gray-800 mb-4">四大保障让您“租的出去，收的回来”</h1>
					<p class="text-lg text-color-cb" style="font-weight:300;">FOUR MAJOR GUARANTEES</p>
				</div>

				<!-- 四大保障卡片 -->
				<div class="grid grid-cols-2 gap-8 max-width mx-auto">
					<!-- 资深团队 -->
					<div class="bg-white rounded-lg p-8 shadow-sm" style="padding-right: 0px;">
						<div class="flex items-start justify-between">
							<div class="flex-1">
								<h3 class="text-xl font-bold text-gray-800 mb-2">01.资深团队</h3>
								<h3 class="text-xl font-bold text-gray-800 mb-10">深耕行业二十一载 业务落地有保障</h3>
								<p class="contant-text leading-relaxed text-lg w-80">
									迪瓜租机在技术开发、平台运营、风控管理、后台支撑等各个业务板块都已形成完善的管理体系，为商户的租赁生意保驾护航。
								</p>
							</div>
							<div class="relative" style="width: 21rem;">
								<img
									:src="require('@/assets/img/Group 427320768@2x.png')"
									class="img-Settle"
									alt="专业团队"
								/>
							</div>
						</div>
					</div>

					<!-- 智能风控 -->
					<div class="bg-white rounded-lg p-8 shadow-sm" style="padding-right: 0px;">
						<div class="flex items-start justify-between">
							<div class="flex-1">
								<h3 class="text-xl font-bold text-gray-800 mb-2">02.资深风控</h3>
								<h3 class="text-xl font-bold text-gray-800 mb-10">支付宝信用体系+自建AI风控模型</h3>
								<p class="contant-text leading-relaxed text-lg w-80">反欺诈、信用评估降低逾期风险</p>
							</div>
							<div class="relative">
								<img
									:src="require('@/assets/img/Group 427320771@2x.png')"
									class="img-Settle"
									alt="智能风控"
								/>
							</div>
						</div>
					</div>

					<!-- 全程监管 -->
					<div class="bg-white rounded-lg p-8 shadow-sm" style="padding-right: 0px;">
						<div class="flex items-start justify-between">
							<div class="flex-1">
								<h3 class="text-xl font-bold text-gray-800 mb-2">03.监管保障</h3>
								<h3 class="text-xl font-bold text-gray-800 mb-10">全流程数据管理</h3>
								<p class="contant-text leading-relaxed text-lg w-80">
									商户收益清晰可见订单情况实时同步 分账对账查账一目了然
								</p>
							</div>
							<div class="relative" style="width: 21rem;">
								<img
									:src="require('@/assets/img/Group 427320767@2x.png')"
									class="img-Settle"
									alt="全程监管"
								/>
							</div>
						</div>
					</div>

					<!-- 快速理赔 -->
					<div class="bg-white rounded-lg p-8 shadow-sm" style="padding-right: 0px;">
						<div class="flex items-start justify-between">
							<div class="flex-1">
								<h3 class="text-xl font-bold text-gray-800 mb-2">04.理赔保障</h3>
								<h3 class="text-xl font-bold text-gray-800 mb-10">赔付设备价值</h3>
								<p class="contant-text leading-relaxed text-lg w-80">
									区块链存证保险财险承保保险财险承保，赔付设备价值
								</p>
							</div>
							<div class="relative" style="width: 21rem;">
								<img
									:src="require('@/assets/img/Group 427320770@2x.png')"
									class="img-Settle w-full"
									alt="快速理赔"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="max-width mx-auto bg-white">
			<div class="container mx-auto px-4 py-12 max-width">
				<!-- 标题区域 -->
				<div class="text-center mb-16">
					<h1 class="text-3xl font-bold text-gray-800 mb-2">企业实力</h1>
					<p class="text-lg text-color-cb" style="font-weight:300;">ENTERPRISE STRENGTH</p>
				</div>

				<!-- 分类标签 -->
				<div class="flex justify-center gap-8 mb-16">
					<button
						class="!rounded-button tabButton px-8 py-3 text-lg whitespace-nowrap"
						@click="handleTab(1)"
						:class="tabActive === 1 ? 'is-active' : ''"
					>
						行业权威
					</button>
					<button
						class="!rounded-button tabButton px-8 py-3 text-lg whitespace-nowrap"
						@click="handleTab(2)"
						:class="tabActive === 2 ? 'is-active' : ''"
					>
						荣誉公示
					</button>
					<button
						class="!rounded-button tabButton px-8 py-3 text-lg whitespace-nowrap"
						@click="handleTab(3)"
						:class="tabActive === 3 ? 'is-active' : ''"
					>
						大牌合作
					</button>
				</div>
				<div v-if="tabActive === 1">
					<!-- 证书展示区域 -->
					<div class="w-full">
						<img :src="certImage" class="w-full h-[360px] object-cover rounded-md" />
					</div>

					<!-- 合作伙伴 -->
					<div class="rounded-lg p-8">
						<div class="flex justify-center items-center gap-16">
							<div
								v-for="(partner, index) in partners"
								:key="index"
								class="flex items-center justify-center"
							>
								<img :src="partner.logo" :alt="partner.name" class="h-16 object-contain smallImg" />
							</div>
							<h2 class="text-2xl font-bold text-center text-gray-800">国内三大运营商深度合作</h2>
						</div>
					</div>
				</div>

				<div v-if="tabActive === 2">
					<!-- 证书展示区域 -->
					<div class="w-full">
						<img :src="honorImage" class="w-full h-[360px] object-cover rounded-md" />
					</div>

					<!-- 合作伙伴 -->
					<div class="rounded-lg p-8">
						<div class="flex justify-center items-center gap-16">
							<div class="flex items-center justify-center">
								<!-- <img
                  :src="partner.logo"
                  :alt="partner.name"
                  class="h-16 object-contain smallImg"
                /> -->
							</div>
							<h2 class="text-2xl font-bold text-center text-gray-800">重视开发 技术实力强劲</h2>
						</div>
					</div>
				</div>

				<div v-if="tabActive === 3">
					<!-- 证书展示区域 -->
					<div class="w-full">
						<img :src="brandImage" class="w-full h-[360px] object-cover rounded-md" />
					</div>

					<!-- 合作伙伴 -->
					<div class="rounded-lg p-6">
						<div class="flex justify-center items-center gap-8">
							<div v-for="(brand, index) in brands" :key="index" class="flex items-center justify-center">
								<img
									:src="brand.logo"
									:alt="brand.name"
									class="object-contain"
									:class="index == 0 ? 'brandSmallImg' : 'smallImg'"
								/>
							</div>
							<h2 class="text-2xl font-bold text-center text-gray-800">拥有各大品牌手机的代理商资质</h2>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="relative">
			<img :src="image" alt="" />
			<div class="w-full h-100" style="margin-top: -290px; text-align: center">
				<img src="https://diguazu.oss-cn-shenzhen.aliyuncs.com/applet/2021003131606511_circle_blue_slogan_8cm.jpg" alt="" class="mx-auto SettledImg" />
<!--				<el-button @click="handleSettaled" type="primary" class="mx-auto mt-6 settledbtn">立即加盟</el-button>-->
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'App',
	data() {
		return {
			image: require('@/assets/img/Group 427320731@2x.png'),
			certImage: require('@/assets/img/Group 427320719@2x.png'),
			honorImage: require('@/assets/img/Group 427320727@2x.png'),
			brandImage: require('@/assets/img/Group 427320726@2x.png'),
			SettledImg: require("@/assets/img/image 1144@2x.png"),

			imageUrls: {
				supply: require('@/assets/img/Group 427320695@2x.png'),
				traffic: require('@/assets/img/Group 427320696@2x.png'),
				enterprise: require('@/assets/img/Group 427320697@2x.png'),
			},
			partners: [
				{
					name: '中国移动',
					logo: require('@/assets/img/image 1128@2x.png'),
				},
				{
					name: '中国联通',
					logo: require('@/assets/img/Group 427320722@2x.png'),
				},
				{
					name: '中国电信',
					logo: require('@/assets/img/image 1130@2x.png'),
				},
			],
			brands: [
				{
					name: '苹果',
					logo: require('@/assets/img/image 1131@2x.png'),
				},
				{
					name: '华为',
					logo: require('@/assets/img/image 1133@2x.png'),
				},
				{
					name: 'VIVO',
					logo: require('@/assets/img/image 1132@2x.png'),
				},
				{
					name: 'OPPO',
					logo: require('@/assets/img/image 1134@2x.png'),
				},
			],
			tabActive: 1,
		};
	},
	created() {},
	mounted() {},
	beforeDestroy() {},
	methods: {
    handleSettaled(){
      this.$router.push('/Contact')
    },
		handleTab(index) {
			this.tabActive = index;
		},
	},
};
</script>

<style scoped lang="scss">
.advantage-card {
	@apply bg-white rounded-lg p-4 text-center transition-all duration-300;
}
.advantage-image-wrapper {
	@apply w-64 h-64 mx-auto  overflow-hidden;
	border-radius: 12px;
}
.advantage-card:hover {
	border-style: solid;
	border-color: #93c5fd;
}
.carousel {
	position: relative;
}
.carousel-indicators {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 141px;
	padding: 0 260px;
	background: rgba(255, 255, 255, 0.5);
	backdrop-filter: blur(10px);
}
.bigGreen-text {
	font-family:
		PingFang SC,
		PingFang SC;
	font-weight: 600;
	font-size: 64px;
	color: #00733d;
	line-height: 90px;
	text-align: center;
	font-style: normal;
	text-transform: none;
}
.title-2 {
	background: #f7f8f7;
	border-radius: 0px 0px 0px 0px;
}
.bg-neutral-100 {
	background: #f7f8f7;
}
.contant-text {
	font-family:
		PingFang SC,
		PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 31px;
	text-align: left;
	font-style: normal;
	text-transform: none;
}
.certificate-grid {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 1.5rem;
}

.certificate-card {
	background: white;
	border-radius: 0.5rem;
	overflow: hidden;
	transition: transform 0.3s ease;
}

.certificate-card:hover {
	transform: scale(1.05);
}

.partner-logo {
	max-width: 160px;
	height: auto;
}
.smallImg {
	width: 95px;
}
.brandSmallImg {
	width: 25px;
}
.tabButton {
	border-radius: 50px;
	font-weight: 500;
	&:hover {
		background: #00733d;
		color: #fff;
	}
}
.settledbtn {
	background: #00733d;
	border: #00733d 1px solid;
	&:hover {
		background: #028f4d;
	}
}
.topSettledbtn{
  margin: -280px auto;
  text-align: center;
}
.is-active {
	background: #00733d;
	color: #fff;
}
.SettledImg {
	width: 7rem;
	border-radius: 17px;
}
.img-Settle{
	width: 21rem;
	height:17rem;
}
</style>
